/**
 * Desktop mega menu: swap right banner image on sub-link hover.
 * Persists last hovered image when the menu closes and restores it when reopening the same top-level item.
 */
(function () {
  const DESKTOP_MQ = '(min-width: 990px)';
  const attached = new WeakSet();
  /** Avoid duplicate preload requests across mega menus */
  const preloadedUrls = new Set();

  function preloadUrl(url) {
    if (!url || preloadedUrls.has(url)) return;
    preloadedUrls.add(url);
    const pre = new Image();
    pre.src = url;
  }

  function preloadMegaMenuImages(megaMenu, defaultUrl) {
    if (defaultUrl) preloadUrl(defaultUrl);
    megaMenu.querySelectorAll('a[data-mega-hover-image]').forEach((a) => {
      const u = a.dataset.megaHoverImage;
      if (u) preloadUrl(u);
    });
  }

  function applyImageUrl(img, url) {
    if (!img || !url) return;
    img.src = url;
    img.removeAttribute('srcset');
    const picture = img.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((s) => s.remove());
    }
    const host = img.closest('responsive-image');
    if (host) {
      host.classList.add('m-image-loaded');
    }
  }

  function bindMegaMenu(megaMenu) {
    const img = megaMenu.querySelector('img.m-mega-hover-img');
    if (!img) return;

    const firstHoverFromNav = () => {
      const a = megaMenu.querySelector('a[data-mega-hover-image]');
      return (a && a.dataset.megaHoverImage) || '';
    };

    const defaultUrl =
      megaMenu.dataset.megaHoverDefault || firstHoverFromNav() || '';

    if (!defaultUrl) return;

    const menuItem = megaMenu.closest('.m-menu__item--mega');
    if (!menuItem) return;

    let lastApplied = '';

    const applyUrl = (url) => {
      if (!url || url === lastApplied) return;
      lastApplied = url;
      applyImageUrl(img, url);
    };

    menuItem.addEventListener('mouseenter', () => {
      preloadMegaMenuImages(megaMenu, defaultUrl);
      lastApplied = '';
      const last = megaMenu.dataset.lastHoverImage;
      applyUrl(last || defaultUrl);
    });

    megaMenu.addEventListener('mouseenter', () => {
      preloadMegaMenuImages(megaMenu, defaultUrl);
    });

    megaMenu.addEventListener(
      'pointerover',
      (e) => {
        const a = e.target.closest('a[data-mega-hover-image]');
        if (!a || !megaMenu.contains(a)) return;
        const url = a.dataset.megaHoverImage;
        if (!url) return;
        applyUrl(url);
        megaMenu.dataset.lastHoverImage = url;
      },
      true
    );
  }

  function init() {
    if (!window.matchMedia(DESKTOP_MQ).matches) return;

    document.querySelectorAll('.m-menu__item--mega .m-mega-menu').forEach((megaMenu) => {
      if (attached.has(megaMenu)) return;
      if (!megaMenu.querySelector('img.m-mega-hover-img')) return;
      if (!megaMenu.dataset.megaHoverDefault && !megaMenu.querySelector('a[data-mega-hover-image]')) return;
      attached.add(megaMenu);
      bindMegaMenu(megaMenu);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
